export const providerWeightings = {
  Home: {
    evolution: 0,
    habanero: 1,
    'on air entertainment': 2,
    'Pragmatic Play': 3,
    playtech: 4,
    'split the pot': 5,
    betgames: 6,
    spribe: 6,
  },
  'Spin Games': {
    habanero: 0,
    evolution: 1,
    playtech: 2,
    'Pragmatic Play': 3,
    'Smartsoft Gaming': 4,
    spribe: 5,
  },
  'Live Games': {
    evolution: 0,
    'on air entertainment': 1,
    'Pragmatic Play': 2,
  },
  'Crash Games': {
    'split the pot': 0,
    betgames: 1,
    spribe: 2,
  },
};
